import React, { useContext } from 'react';

import { BaseLink } from '@snapask/common-components';
import { DEFAULT } from '@snapask/common-components/dist/constants/commonType';

import ApplicationContext from '@blueberry/components/ApplicationContext';

const Link = props => {
  const { history } = useContext(ApplicationContext);

  return (
    <BaseLink
      pathname={history.location.pathname}
      history={history}
      type={DEFAULT}
      {...props}
    />
  );
};

export default Link;



// WEBPACK FOOTER //
// ./app/components/Link/Link.jsx